"use client";

import { useEffect } from "react";

/* Scroll slide-up reveal + stat count-up, scoped to .gp-page */
export default function GlobalEffects() {
  useEffect(() => {
    const root = document.querySelector(".gp-page");
    if (!root) return;
    root.classList.add("gp-js");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const countUp = (el: HTMLElement) => {
      const target = Number(el.dataset.count);
      const suffix = el.dataset.suffix ?? "";
      if (reduce || Number.isNaN(target)) return;
      const t0 = performance.now();
      const tick = (t: number) => {
        const p = Math.min((t - t0) / 1000, 1);
        el.textContent = `${Math.round(target * (1 - Math.pow(1 - p, 3)))}${suffix}`;
        if (p < 1) requestAnimationFrame(tick);
      };
      el.textContent = `0${suffix}`;
      requestAnimationFrame(tick);
    };

    const els = root.querySelectorAll<HTMLElement>(".gp-reveal, .gp-stagger, .gp-card, [data-count]");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target as HTMLElement;
          el.classList.add("is-visible");
          if (el.dataset.count) countUp(el);
          io.unobserve(el);
        }),
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return null;
}
